module.exports = __webpack_public_path__ + "img/dep_grocery.db655c45.png";